import objectFitImages from 'object-fit-images';
import '../modules/dep/jquery-ui.min';
import { $document, Resp } from '../modules/dev/helpers';
import './noTouch';
import './preloader';
import './select';

/**
 * Website's common scripts.
 *
 * @module Common
 */
export class Common {
	constructor() {
		this.init();
		if (!Resp.isMobile) this.resizeHistoryTitle();
	}
	
	init() {
		objectFitImages();
	}
	
	resizeHistoryTitle() {
		$document.ready(() => {
			setTimeout(() => {
				const $historyItem = $('.history__item');
				const historyTitle = '.history__title';
				
				$historyItem.each((index, el) => {
					const $item = $(el);
					const itemHeight = Resp.isDesk ? $item.children().first().height() - 25 : $item.children().first().height();
					const $title = $item.find(historyTitle);
					
					$title.css('line-height', +$title.css('line-height').slice(0, -2) / +$title.css('font-size').slice(0, -2));
					
					checkTitle();
					
					function checkTitle() {
						if ($title.outerHeight() > itemHeight) {
							$title.css('font-size', +$title.css('font-size').slice(0, -2) - 1);
							checkTitle();
						}
					}
				});
			}, 0);
		});
	}
}

export default new Common;



// WEBPACK FOOTER //
// ./src/js/components/common.js